import { render, staticRenderFns } from "./oldHealthy.vue?vue&type=template&id=59c74d8c&scoped=true"
import script from "./oldHealthy.vue?vue&type=script&lang=js"
export * from "./oldHealthy.vue?vue&type=script&lang=js"
import style0 from "./oldHealthy.vue?vue&type=style&index=0&id=59c74d8c&prod&lang=scss&scoped=true"
import style1 from "./oldHealthy.vue?vue&type=style&index=1&id=59c74d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c74d8c",
  null
  
)

export default component.exports